(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7156"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7156"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3RTuP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d115ebf5121a993$export$2e2bcd8739ae039; });

var $7gIxp = parcelRequire("7gIxp");
class $2d115ebf5121a993$export$2e2bcd8739ae039 {
    constructor({ canvas: canvas, width: width = 500, height: height = 500, padding: padding = 20, context: context = "2d", fps: fps = 60 }){
        this.canvas = canvas;
        this.ctx = this.canvas.getContext(context);
        this.canvas.setAttribute("width", width);
        this.canvas.setAttribute("height", height);
        this.width = width;
        this.height = height;
        this.centerX = width / 2;
        this.centerY = height / 2;
        this.padding = padding;
        this.innerWidth = this.width - 2 * this.padding;
        this.innerHeight = this.height - 2 * this.padding;
        this.drawId = null;
        this.fps = fps;
    }
    setup() {}
    update() {}
    draw() {}
    mouseClick(x, y) {}
    async start() {
        this.canvas.width = this.width;
        this.canvas.height = this.height;
        this.canvas.addEventListener("click", this.eventClick.bind(this), false);
        await this.setup();
        this.drawId = requestAnimationFrame(this.tick.bind(this));
    }
    tick() {
        const startTime = Date.now();
        this.update();
        this.draw();
        const endTime = Date.now();
        const deltaTime = endTime - startTime;
        const waitTime = 1000 / this.fps - deltaTime;
        if (waitTime > 0) setTimeout(()=>{
            this.drawId = requestAnimationFrame(this.tick.bind(this));
        }, waitTime);
        else this.drawId = requestAnimationFrame(this.tick.bind(this));
    }
    eventClick(e) {
        // get position of cursor relative to top left of canvas
        let x;
        let y;
        if (e.pageX || e.pageY) {
            x = e.pageX;
            y = e.pageY;
        } else {
            x = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
        }
        x -= this.canvas.offsetLeft;
        y -= this.canvas.offsetTop;
        this.mouseClick(x, y);
    }
    clear() {
        this.ctx.clearRect(0, 0, this.width, this.height);
    }
    drawRectangle(x, y, w, h, color) {
        this.ctx.beginPath();
        this.ctx.rect(x, y, w, h);
        this.ctx.closePath();
        this.ctx.fillStyle = color;
        this.ctx.fill();
    }
    drawCircle(x, y, r, color) {
        this.ctx.beginPath();
        this.ctx.arc(x, y, r, 0, Math.PI * 2, true);
        this.ctx.closePath();
        this.ctx.fillStyle = color;
        this.ctx.fill();
    }
    drawCoordinatePlan(xMin = -5, xMax = 5, yMin = -5, yMax = 5) {
        const padding = 20;
        const innerWidth = this.width - 2 * padding;
        const innerHeight = this.height - 2 * padding;
        const mapX = (x)=>padding + (x - xMin) / (xMax - xMin) * innerWidth;
        const mapY = (y)=>this.height - padding - (y - yMin) / (yMax - yMin) * innerHeight;
        this.ctx.lineWidth = 1;
        this.ctx.setLineDash([]);
        // Draw the x-axis
        this.ctx.beginPath();
        this.ctx.moveTo(padding, this.centerY);
        this.ctx.lineTo(this.width - padding, this.centerY);
        this.ctx.strokeStyle = "#100c09";
        this.ctx.stroke();
        // Draw the y-axis
        this.ctx.beginPath();
        this.ctx.moveTo(this.centerX, padding);
        this.ctx.lineTo(this.centerX, this.height - padding);
        this.ctx.strokeStyle = "#100c09";
        this.ctx.stroke();
        // Draw ticks and labels on x-axis
        (0, $7gIxp.default)(xMin, xMax + 1).forEach((x, i)=>{
            const xPos = mapX(x);
            this.ctx.beginPath();
            this.ctx.moveTo(xPos, this.centerY - 5);
            this.ctx.lineTo(xPos, this.centerY + 5);
            this.ctx.stroke();
            if (x !== 0 && !(i % 2)) this.ctx.fillText(x, xPos - 3, this.centerY + 15);
        });
        // Draw ticks and labels on y-axis
        (0, $7gIxp.default)(yMin, yMax + 1).forEach((y, i)=>{
            const yPos = mapY(y);
            this.ctx.beginPath();
            this.ctx.moveTo(this.centerX - 5, yPos);
            this.ctx.lineTo(this.centerX + 5, yPos);
            this.ctx.stroke();
            if (y !== 0 && !(i % 2)) this.ctx.fillText(y, this.centerX + 10, yPos + 3);
        });
    }
}

});
parcelRegister("7gIxp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54ac9355d1c100e3$export$2e2bcd8739ae039; });
var $54ac9355d1c100e3$export$2e2bcd8739ae039 = (from, to, increment = 1)=>[
        ...Array(Math.ceil((to - from) / increment)).keys()
    ].map((i)=>from + i * increment);

});


parcelRegister("aYzlj", function(module, exports) {

$parcel$export(module.exports, "generateLinearData", function () { return $7fdaec4d1c0ed861$export$6c2fe876829088e1; });
$parcel$export(module.exports, "default", function () { return $7fdaec4d1c0ed861$export$2e2bcd8739ae039; });
const $7fdaec4d1c0ed861$var$getRandomBetween = (low, high)=>Math.random() * (high - low) + low;
const $7fdaec4d1c0ed861$export$5907fc7152c4333c = (nSamples)=>{
    const data = [];
    const labels = [];
    Array.from({
        length: nSamples / 2
    }).forEach(()=>{
        const r = $7fdaec4d1c0ed861$var$getRandomBetween(0.05, 0.2);
        const t = Math.random() * 2 * Math.PI;
        data.push([
            0.5 + r * Math.sin(t),
            0.5 + r * Math.cos(t)
        ]);
        labels.push(1);
    });
    Array.from({
        length: nSamples / 2
    }).forEach(()=>{
        const r = $7fdaec4d1c0ed861$var$getRandomBetween(0.3, 0.45);
        const t = Math.random() * 2 * Math.PI;
        data.push([
            0.5 + r * Math.sin(t),
            0.5 + r * Math.cos(t)
        ]);
        labels.push(-1);
    });
    return [
        data,
        labels
    ];
};
const $7fdaec4d1c0ed861$export$6f53b2aedd0eab0b = (nSamples)=>{
    const data = [];
    const labels = [];
    Array.from({
        length: nSamples / 2
    }).forEach((_, i)=>{
        const r = i / (nSamples / 2) * 0.5;
        const t = 1.25 * i / (nSamples / 2) * 2 * Math.PI;
        data.push([
            0.5 + r * Math.sin(t),
            0.5 + r * Math.cos(t)
        ]);
        labels.push(1);
    });
    Array.from({
        length: nSamples / 2
    }).forEach((_, i)=>{
        const r = i / (nSamples / 2) * 0.5;
        const t = 1.25 * i / (nSamples / 2) * 2 * Math.PI + Math.PI;
        data.push([
            0.5 + r * Math.sin(t),
            0.5 + r * Math.cos(t)
        ]);
        labels.push(-1);
    });
    return [
        data,
        labels
    ];
};
const $7fdaec4d1c0ed861$export$6c2fe876829088e1 = (nSamples, fn = (x, y)=>y > 0.4 * x + 0.2 && -1 || 1)=>{
    const data = [];
    const labels = [];
    Array.from({
        length: nSamples
    }).forEach(()=>{
        const x = $7fdaec4d1c0ed861$var$getRandomBetween(0, 0.99);
        const y = $7fdaec4d1c0ed861$var$getRandomBetween(0, 0.99);
        data.push([
            x,
            y
        ]);
        labels.push(fn(x, y));
    });
    return [
        data,
        labels
    ];
};
const $7fdaec4d1c0ed861$var$generatePatternData = (shape, nSamples)=>{
    switch(shape){
        case "circles":
            return $7fdaec4d1c0ed861$export$5907fc7152c4333c(nSamples);
        case "spirals":
            return $7fdaec4d1c0ed861$export$6f53b2aedd0eab0b(nSamples);
        case "linear":
            return $7fdaec4d1c0ed861$export$6c2fe876829088e1(nSamples);
        default:
            return [];
    }
};
var $7fdaec4d1c0ed861$export$2e2bcd8739ae039 = $7fdaec4d1c0ed861$var$generatePatternData;

});


var $d2Bw1 = parcelRequire("d2Bw1");

var $3RTuP = parcelRequire("3RTuP");

var $aYzlj = parcelRequire("aYzlj");

var $7gIxp = parcelRequire("7gIxp");

var $d2Bw1 = parcelRequire("d2Bw1");
const $15a252a1a2be8c7c$var$buildModel = ()=>{
    const numOfInputs = 2;
    const layer1 = new (0, $d2Bw1.Layer)({
        numOfInputs: numOfInputs,
        numOfNeurons: 16
    });
    const layer2 = new (0, $d2Bw1.Layer)({
        numOfInputs: 16,
        numOfNeurons: 16
    });
    const layer3 = new (0, $d2Bw1.Layer)({
        numOfInputs: 16,
        numOfNeurons: 1,
        activation: "linear"
    });
    const model = new (0, $d2Bw1.Sequential)({
        layers: [
            layer1,
            layer2,
            layer3
        ]
    });
    return model;
};
var $15a252a1a2be8c7c$export$2e2bcd8739ae039 = $15a252a1a2be8c7c$var$buildModel;



var $2P5ac = parcelRequire("2P5ac");
const $16768feb212b79ae$var$size = Math.min(+document.querySelector(".demo").offsetWidth, 600);
const $16768feb212b79ae$var$percent = (v)=>new Intl.NumberFormat("en-US", {
        style: "percent"
    }).format(v);
class $16768feb212b79ae$var$BinaryClassification extends (0, $3RTuP.default) {
    constructor({ canvas: canvas, lossCanvas: lossCanvas }){
        super({
            canvas: canvas
        });
        this.pattern = "circles";
        this.lossCanvas = lossCanvas;
        this.ctxLoss = this.lossCanvas.getContext("2d");
        this.lossCanvas.setAttribute("width", $16768feb212b79ae$var$size);
        this.lossCanvas.setAttribute("height", 200);
        this.model = (0, $15a252a1a2be8c7c$export$2e2bcd8739ae039)();
        this.training = false;
        this.trainId = null;
        this.drawId = null;
        this.maxEpochs = 500;
        this.trainingData = [];
        this.lossHistory = [];
    }
    getPattern() {
        return this.pattern;
    }
    setPattern(pattern) {
        this.pattern = pattern;
    }
    mapX(x) {
        return this.padding + x * this.innerWidth;
    }
    mapY(y) {
        return this.height - this.padding - y * this.innerHeight;
    }
    plotPattern() {
        const [data, labels] = this.trainingData;
        data.forEach((point, index)=>{
            const [x, y] = point;
            const label = labels[index];
            const color = label === 1 && "#3a7ca5" || label === -1 && "#f6511d" || "#006632";
            this.drawCircle(this.mapX(x), this.mapY(y), 5, color);
        });
    }
    plotBoundaries() {
        const step = 0.05;
        const xRange = (0, $7gIxp.default)(0, 1, step);
        const yRange = (0, $7gIxp.default)(0, 1, step);
        yRange.forEach((y)=>{
            xRange.forEach((x)=>{
                const prediction = this.model.forward([
                    x,
                    y
                ]);
                const label = prediction.data > 0 ? 1 : -1;
                const color = label === 1 && "rgb(58 124 165 / 20%)" || label === -1 && "rgb(246 81 29 / 20%)" || "rgb(0 102 50 / 20%)";
                this.drawRectangle(this.mapX(x), this.mapY(y), step * this.innerWidth, step * this.innerHeight, color);
            });
        });
    }
    plotLossCurve() {
        const { lossCanvas: lossCanvas, ctxLoss: ctxLoss, lossHistory: lossHistory } = this;
        if (lossHistory.length < 2) return;
        const { width: width } = lossCanvas;
        const { height: height } = lossCanvas;
        const padding = 25;
        const plotWidth = width - 2 * padding;
        const plotHeight = height - 2 * padding;
        // Clear the previous plot
        ctxLoss.clearRect(0, 0, width, height);
        // Set up the drawing area
        ctxLoss.strokeStyle = "#856a5d";
        ctxLoss.lineWidth = 2;
        ctxLoss.beginPath();
        // Find the maximum loss for scaling
        const maxLoss = Math.max(...lossHistory);
        lossHistory.forEach((loss, index)=>{
            const x = padding + index / (this.maxEpochs - 1) * plotWidth;
            const y = height - padding - loss / maxLoss * plotHeight;
            if (index === 0) ctxLoss.moveTo(x, y);
            else ctxLoss.lineTo(x, y);
        });
        ctxLoss.stroke();
        ctxLoss.closePath();
        // Draw x-axis
        ctxLoss.strokeStyle = "#100c09";
        ctxLoss.beginPath();
        ctxLoss.moveTo(padding, height - padding);
        ctxLoss.lineTo(width - padding, height - padding);
        ctxLoss.stroke();
        ctxLoss.closePath();
        // Draw y-axis
        ctxLoss.beginPath();
        ctxLoss.moveTo(padding, height - padding);
        ctxLoss.lineTo(padding, padding);
        ctxLoss.stroke();
        ctxLoss.closePath();
        // Add x-axis label
        ctxLoss.fillStyle = "#100c09";
        ctxLoss.font = "12px Arial";
        ctxLoss.fillText("Epochs", width / 2, height - padding / 4);
        // Add y-axis label
        ctxLoss.save();
        ctxLoss.translate(padding / 2, height / 2);
        ctxLoss.rotate(-Math.PI / 2);
        ctxLoss.textAlign = "center";
        ctxLoss.fillText("Loss", 0, 0);
        ctxLoss.restore();
    }
    train() {
        const [xs, ys] = this.trainingData;
        let epoch = 0;
        let learningRate = 0.8;
        const alpha = 1e-4;
        const batch = xs.length;
        const trainStep = ()=>{
            if (!this.training) return;
            // Shuffle and get batch indices
            let indices = (0, $7gIxp.default)(0, xs.length).sort(()=>Math.random() - 0.5);
            if (batch) indices = indices.slice(0, batch);
            const yPredictions = indices.map((index)=>this.model.forward(xs[index]));
            const losses = yPredictions.reduce((acc, yPrediction, index)=>{
                const loss = yPrediction.mul(-ys[indices[index]]).add(1).relu();
                return loss.add(acc);
            }, new (0, $d2Bw1.Value)(0));
            const dataLoss = losses.div(yPredictions.length);
            const regLoss = new (0, $d2Bw1.Value)(alpha).mul(this.model.parameters().reduce((acc, p)=>acc.add(p.pow(2)), new (0, $d2Bw1.Value)(0)));
            const totalLoss = dataLoss.add(regLoss);
            const correct = yPredictions.filter((y, index)=>y.data > 0 === ys[indices[index]] > 0).length;
            const accuracy = correct / yPredictions.length;
            // Backward pass
            this.model.zeroGrad();
            totalLoss.backward();
            // update weights
            learningRate *= 0.99;
            this.model.parameters().forEach((p)=>{
                p.data -= learningRate * p.grad;
            });
            this.model.epoch = epoch;
            this.model.loss = totalLoss.data;
            this.model.accuracy = accuracy;
            this.lossHistory.push(totalLoss.data);
            console.info(`Epoch: ${epoch}, Loss: ${totalLoss.data.toFixed(5)}, Accuracy: ${$16768feb212b79ae$var$percent(accuracy)}, Learning Rate: ${learningRate.toFixed(5)}`);
            epoch += 1;
            if (epoch > this.maxEpochs) return;
            this.trainId = setTimeout(trainStep, 100);
        };
        trainStep();
    }
    setup() {
        const pattern = this.getPattern();
        console.info(`New model for expression: ${pattern}`);
        this.model = (0, $15a252a1a2be8c7c$export$2e2bcd8739ae039)();
        this.trainingData = (0, $aYzlj.default)(pattern, 100);
        this.lossHistory = [];
        this.training = true;
        this.train();
        (0, $2P5ac.default)(".architecture", $16768feb212b79ae$var$size, this.model.toString());
    }
    draw() {
        this.clear();
        this.plotBoundaries();
        this.plotPattern();
        this.plotLossCurve();
        const formatter = new Intl.NumberFormat("en-US", {
            style: "decimal",
            maximumFractionDigits: 0
        });
        document.querySelector("#epoch .value").innerText = formatter.format(this.model.epoch);
        document.querySelector("#loss .value").innerText = this.model.loss.toFixed(5);
        document.querySelector("#accuracy .value").innerText = $16768feb212b79ae$var$percent(this.model.accuracy);
    }
    stop() {
        this.training = false;
        clearTimeout(this.trainId);
        cancelAnimationFrame(this.drawId);
    }
    restart() {
        this.stop();
        this.start();
    }
}
const $16768feb212b79ae$var$classifier = new $16768feb212b79ae$var$BinaryClassification({
    canvas: document.getElementById("plane"),
    lossCanvas: document.getElementById("lossCurve"),
    padding: 0,
    width: $16768feb212b79ae$var$size,
    height: $16768feb212b79ae$var$size
});
$16768feb212b79ae$var$classifier.start();
const $16768feb212b79ae$var$reload = (pattern)=>{
    $16768feb212b79ae$var$classifier.setPattern(pattern);
    $16768feb212b79ae$var$classifier.restart();
};
const $16768feb212b79ae$var$buttons = document.querySelectorAll(".types button");
$16768feb212b79ae$var$buttons.forEach((button)=>{
    button.addEventListener("click", ()=>{
        const pattern = button.getAttribute("data-pattern");
        $16768feb212b79ae$var$reload(pattern);
    });
});

})();
//# sourceMappingURL=binary-classification.8cd1c26d.js.map
